import { FileFavoritesDto } from '../dto'
import { FileFavoritesModel } from '../models'

export const fileFavoritesDtoToModelTransformer = (dto: FileFavoritesDto): FileFavoritesModel[] => {
  return dto.favoriteFiles.map(file => {
    return {
      fileInfoId: file.fileInfoId,
      createdAt: file.createdAt,
      downloadItemId: file.downloadItemId,
      fileName: file.fileName,
      fileType: file.fileType,
      parents: file.parents,
    }
  })
}
